<mat-form-field appearance="outline">
    <mat-label>Buscar</mat-label>
    <input matInput  (keyup)="applyFilter($event)" #input>
</mat-form-field>

<div class="mat-elevation-z0">
<table mat-table [dataSource]="dataSource" matSort >
    <!-- Spinner de carga -->
    <div *ngIf="loadingData" class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Folio </th>
        <td class="padding-table" mat-cell *matCellDef="let element"> {{ element.folio}} </td>
    </ng-container>

    <ng-container matColumnDef="Inicio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Inicio</th>
        <td  class="padding-table" mat-cell *matCellDef="let element"><i class="pi pi-circle-off" style="color:rgb(54, 222, 54); font-size: smaller;"></i> {{element.f_start}} </td>
    </ng-container>

    <ng-container matColumnDef="Termino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Termino</th>
        <td mat-cell *matCellDef="let element"> <i class="pi pi-circle-off" style="color:rgb(222, 54, 54);font-size: smaller;"></i> {{ element.f_end}} </td>
    </ng-container>

    <ng-container matColumnDef="Habiles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>D. Habiles </th>
        <td class="padding-table" mat-cell *matCellDef="let element"> <i class="pi pi-check-circle" style="color:rgb(54, 222, 54);font-size: smaller;"></i> {{ element.habiles}}</td>
    </ng-container>


    <ng-container matColumnDef="Inhabiles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>D. Inhabiles </th>
        <td class="padding-table" mat-cell *matCellDef="let element"> <i class="pi pi-ban mr-1" style="color:rgb(222, 54, 54);font-size: smaller;"></i>{{ element.inhabiles}}</td>
    </ng-container>



    <ng-container matColumnDef="Pendiente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>D. Pendientes </th>
        <td class="padding-table" mat-cell *matCellDef="let element"> <i class="pi pi-refresh" style="color:rgb(211, 208, 15);font-size: smaller;"></i> {{ element.pendiente}}</td>
    </ng-container>
    <ng-container matColumnDef="Periodo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Periodo </th>
        <td class="padding-table" mat-cell *matCellDef="let element"> <i class="pi pi-calendar" style="color:rgb(109, 109, 109);font-size: smaller;"></i> {{ element.periodo }}</td>
    </ng-container>

    <ng-container matColumnDef="Acciones">
        <th mat-header-cell *matHeaderCellDef> Acciones </th>
        <td class="padding-table" mat-cell *matCellDef="let element">
            <!-- <button *ngIf="element.estado" (click)="Descargar(element.id)" mat-button class="button_color_primary"
                style="background-color:rgb(37, 199, 228)">
                <mat-icon style="color: white">search</mat-icon>
            </button>&nbsp; -->
            <p-button *ngIf="element.estado" class="mr-2" (click)="Descargar(element.id)" icon="pi pi-search" styleClass="p-button-rounded p-button-primary p-button-text"></p-button>
            <!-- <button (click)="Borrar(element.id)" mat-raised-button color="warn">
                <mat-icon style="color: white">delete</mat-icon>
            </button> -->
            <p-button *ngIf="!isAuditor" class="mr-2" (click)="Borrar(element.id)" icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-text" ></p-button>
            <!-- <button
            *ngIf="!element.estado"
            (click)="open(content,element.id)"
             mat-button
             style="background-color:red"
            >
            <mat-icon style="color: white">file_upload</mat-icon>
            </button> -->
            <p-button *ngIf="!element.estado && !isAuditor" (click)="open(content,element.id)" icon="pi pi-upload" styleClass="p-button-rounded p-button-danger p-button-text" ></p-button>
        </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator
[pageSizeOptions]="[10, 25, 50, 100, 1]"
showFirstLastButtons
aria-label="Seleccionar pagina de Vacaciones."
>
</mat-paginator>
</div>



<!-- MODAL PARA subir Comprobante de vacacion -->
<ng-template style="border: 0px; z-index: 100" #content let-modal>

    <div class="modal-header" style="text-align: center">
        <mat-card-title>Cargar Comprobantes de Vacaciones</mat-card-title>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <app-agregar-vacaciones [id]='id'></app-agregar-vacaciones>

</ng-template>
